import axiosInstances from '../config/axios'
// import { APP_INSTANCE_ARN } from "../config/awsChimeConfig"
import { MessagePayload } from '../components/Chat/types'
import { Buffer } from "buffer";
import { isAndroid, isIOS, osVersion} from "react-device-detect"
import { MessagingConstants } from './enums';
import { channel } from 'diagnostics_channel';
import { UI_ENV } from '../config/awsChimeConfig'
import axios from 'axios';
import messagingService from '../services/MessagingService';
import AWS from 'aws-sdk';
import * as keys from '../config/awsChimeConfig'
import { setJwtToken, setXApiKey } from './cookieUtils';
import { logInfo, logError, logMessageSent } from './rumLogger';
import { getChannelArn } from '../v2/lib/utils';

const { axiosInstance, jobseekerAxiosInstance, coreApiAxiosInstance } = axiosInstances
export const TIMEZONE = 'timezone'
export const TIMEZONE_ABBREV = 'timezoneAbbrev'
export const TIMEZONE_ALTNAME = 'timezoneAltName'
const STORED_MESSAGING_AUTH_KEY =  localStorage?.getItem(`${process.env.REACT_APP_ENV}-messaging`) || ""
export const WEBSOCKET_PRESENCE_MESSAGE = "presence"
export const WEBSOCKET_CONNECTED_MESSAGE = "connected"

export const getUserInstanceArnv2 = async (
  externalSystemUserId: string | null,
  role: string | null,
  messagingUserId: string | null
) => {
  const params = {
    "externalSystemUserId": externalSystemUserId,
    "role": role,
    "messagingUserId": messagingUserId
  }

   return await axiosInstance.post(`/user/lookup`, JSON.stringify(params)).then(res => {
      if (res && res.data) {
        return res.data
      }
    return null
  }).catch( err => {
    return err
  })
}

export const decryptUrl = async (token: string) => {
  const params = {"payload": token}
  return await axiosInstance.post(`/security/decrypt`, JSON.stringify(params)).then(res => {
    if(res && res.data) {
      return res.data
    }
  }).catch(err => {
    return err
  })
}

export const userArn = async (userId:string | null) => {
  try {
    const res = await axiosInstance.get(`/fetch/messaging-app`)
    if (res?.data?.response) {
      const messagingApp = await decryptData(res?.data?.response)
      return `${messagingApp}/user/${userId}`
    } return ''
  } catch (error) {
    logInfo('user_retrieval_error', 'userArn', 'Error retrieving user', undefined, { userId, error })
    return ''
  }
}

export const isIndicatorMessage = (messageContent: string) =>
  messageContent?.match(/\[Indicator/)

export const checkIfBlockIndicatorMessage = (messageContent: string) => {
  return Boolean(messageContent?.match(/\[Indicator:Block]/) || messageContent?.match(/\[Indicator:Unblock]/))
}


/* Retrieves userInstanceArn */
export const getUserInstanceArn = async (email: string) => {
  const params = { "email": email }
   return await axiosInstance.post(`/user/instance-arn/v2`, JSON.stringify(params), { headers : await getStoredMessagingAuth()}).then(res => {
    if (res && res.data) {
      return res.data
    }
    return null
  }).catch( err => {
    return null
  })
}

/* Splits the userId from the userArn */
export const splitUserArn = (userArn: string) => {
    if (!userArn) {
      return ""
    }
    const splitStr = userArn.split('/')
    if (!splitStr || splitStr.length == 0) {
      return ""
    }
    return splitStr[splitStr.length -1]
}

/* Retrieves messages of a channel */
export const listChannelMessages = async (
  channelArn: string,
  senderId: string,
  nextToken?: string
) => {
  const params = {
    "channelArn": channelArn,
    "messagingUserId": senderId,
    ...(nextToken && { "nextToken": nextToken })
  }

  return await axiosInstance.post(`/channel/list-messages`, JSON.stringify(params)).then(res => {
    const messageList = res?.data?.Messages
    const nextToken = res?.data?.NextToken

    if (messageList) {
      messageList.sort(function (a: MessagePayload, b:MessagePayload) {
        return a.CreatedTimestamp < b.CreatedTimestamp
          ? -1
          : a.CreatedTimestamp > b.CreatedTimestamp
          ? 1
          : 0
      })

      const messages = []
      for (let i = 0; i < messageList.length; i++) {
        const message = messageList[i]
        messages.push(message)
      }
      return { Messages: messages, NextToken: nextToken }
    }

    return { Messages: [], NextToken: null }
  }).catch( err => {
    return null
  })
}

/* creates/retrieves the channel name thru discussed pattern */
export const getChannelNamePattern = async (
  firstId: string,
  secondId: string,
  jobId: string
) => {
  const channelName = `${firstId}-${secondId}-${jobId}`
  return channelName?.replace(/\s/g, '')
}

/* splits the channelNamePattern and returns the IDs (senderId, receiverId, jobId)*/
export const splitChannelNamePattern = async (
  channelName: string
) => {
  const splitID = channelName.split('-')
  splitID.forEach(id => {
    
  })
}

/* sends channel message */
export async function sendChannelMessage(
  sender: {
    externalUserId: string;
    messagingId: string;
    role: string;
  },
  receiver: {
    externalUserId: string;
    messagingId: string;
    role: string;
  },
  channelArn: string,
  messageContent: string,
  aiInterviewerLink?: string | null,
  isPresence: boolean = false
) {
  let sentMessage = null;

  const eventMetadata = {
    OtherUsers: [`${receiver.messagingId}+${receiver.role}`],
    Sender: `${sender.messagingId}+${sender.role}`,
  };

  const params: any = {
    channelArn,
    messagingUserId: sender.messagingId,
    messageContent: isPresence ? ' ' : messageContent,
    persistence: isPresence ? 'NON_PERSISTENT' : 'PERSISTENT',
    type: isPresence ? 'CONTROL' : 'STANDARD',
  };

  // Add metadata only for actual chat messages
  if (!isPresence) {
    params.metadata = JSON.stringify({
      link: aiInterviewerLink,
    });
  }

  await axiosInstance
    .post(`/channel/send-message`, JSON.stringify(params))
    .then((response) => {
      sentMessage = {
        response,
        CreatedTimeStamp: new Date(),
        Sender: {
          Arn: sender.externalUserId,
          Id: sender.messagingId,
        },
      };

      const messageId = response?.data?.MessageId ?? '';

      /* MSGT-3838: add action to RUM logger */
      if (!isPresence) {
        publishMessagingEvent(
          'messageSent',
          sender.messagingId,
          channelArn,
          messageId,
          '',
          JSON.stringify(eventMetadata),
          true,
          messageContent
        );

        /* MSGT-4098 Messaging Service - Emit new SNS event when an "Includes" Message is sent (Video Interviewer) */
        if(aiInterviewerLink && aiInterviewerLink !== '' && messageContent.includes(aiInterviewerLink)) {
          publishMessagingEvent(
            'videoInterviewMessageSent',
            sender.messagingId,
            channelArn,
            messageId,
            '',
            JSON.stringify(eventMetadata),
            true,
            messageContent
          )
        }
      }
    })
    .catch((error) => {
      logError(error as Error, 'sendChannelMessage', { channelArn, senderId: sender.messagingId });
    });

  return sentMessage;
}

/* update channel markers */
export const updateChannelMarkerBackend = async(
  channelArn: string | null,
  messagingUserId: string,
  adminId: string,
  marker:string,
  isNull:any,
  receiver: any
) => {
  const params = {
    channelArn,
    messagingUserId,
    adminId,
    marker,
    isNull
  }
  if(channelArn) {
    await axiosInstance.post(`/channel/update-marker?unified=true`,
      JSON.stringify(params)).then(() => {
        let eventName = marker == MessagingConstants.END_CONVERSATION_MARKER ? "channelDisabled" : "channelReenabled"
        publishMessagingEvent(eventName, messagingUserId, channelArn, "", "", "", null, null)
        updateReadMarker(messagingUserId, channelArn, true, receiver).then(() => { return true })
        /* TJSKR-2393: open search integration */
        // openSearchUpdateChannelMarker(messagingUserId, channelArn, marker)
        return false
      }).catch( () => {
        return false
    })
  } return false
}

export function formatDate(timestamp: number, timezone: string | null) {
  const date = new Date(timestamp);
  const defaultTimeZone = 'America/Detroit';
  const timeZone = timezone ? timezone : defaultTimeZone
  const options: Intl.DateTimeFormatOptions = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: timeZone,
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat(undefined, options);
  const parts = formatter.formatToParts(date);

  let month, day, year, hour, minute, ampm;

  parts.forEach(({ type, value }) => {
    switch(type) {
      case 'month':
        month = value;
        break;
      case 'day':
        day = value;
        break;
      case 'year':
        year = value;
        break;
      case 'hour':
        hour = value;
        break;
      case 'minute':
        minute = value;
        break;
      case 'dayPeriod':
        ampm = value;
        break;
    }
  });
  return `${month}/${day}/${year} ${hour}:${minute} ${ampm}`;
}


export const removeFromScreen = async(
  channelArn: string,
  content: string,
  messageId:string,
  messagingUserId: string,
  updateFlag: string) => {
    if(!channelArn || !messageId) return false
    const params = {
      "adminId": messagingUserId,
      "messagingUserId": messagingUserId,
      "updateFlag": updateFlag,
      "channelArn": channelArn,
      "content": content,
      "messageId": messageId
    }
    await axiosInstance.post(`/channel/update-message`, JSON.stringify(params)).then(res => {
      let eventName = updateFlag == MessagingConstants.REMOVED_FROM_SCREEN_TIMESTAMP ? "messageDelete" : "messageUndeleted"
      publishMessagingEvent(eventName, messagingUserId, channelArn, messageId, "", "", null, null)
      return true
    }).catch(err => {
      return false
    })
}

export const deleteChannelMessage = async(
  channelArn: string,
  messageId:string,
  userId: string) => {
  if(!channelArn || !messageId) return false
  const params = {
    "adminId": userId,
    "messagingUserId": userId,
    "channelArn": channelArn,
    "messageId": messageId
  }
  await axiosInstance.post(`/channel/redact-message`, JSON.stringify(params)).then(res => {
    publishMessagingEvent("messageRedacted", userId, channelArn, messageId, "", "", null, null)
    return true
  }).catch(err => {
    return false
  })
}

export const updateTermsOfServiceAgreed = async (userId: string) => {
  const params = { "messagingUserId": userId }
  await axiosInstance.post(`/user/agree-terms-of-service`, JSON.stringify(params)).then(()=> {
    publishMessagingEvent("agreeTermsOfService", userId, "", "", "", "", null, null)
    return true
  }).catch(err => {
    throw err
  })
}

export const createChannel = async (
  channelName: string,
  // jobId: string | null, // remove null
  job: {
    date_applied?: string | null,
    job_id: string | null,
    candidate_id: string | null,
  },
  receiver: {
    messagingId: string,
    externalUserId: string,
    role: string
  },
  sender : {
    externalUserId: string,
    messagingId: string,
    role: string
  },
  channelMetadata?: any,
) => {
  // const metadata = {
  //   "ChannelType": "PUBLIC_STANDARD",
  //   "Members": [`${sender.externalUserId}-${sender.role}`, `${receiver.externalUserId}-${receiver.role}`],
  //   "Admin": sender.messagingId,
  //   "OtherUsers": [receiver.messagingId],
  //   "JobId": job.job_id,
  //   "CandidateId": job.candidate_id,
  //   "Cadences":{"jobseeker":3,"recruiter":4},
  //   "EndConversationTimestamp": null,
  //   "EndOrReenableActionDoer": null,
  //   "ReEnableConversationTimestamp": null,
  //   "DateApplied": job.date_applied
  // }

  const metadata = {
    ChannelType: "PUBLIC_STANDARD",
    Members: [
      `${sender.externalUserId}-${sender.role}`,
      `${receiver.externalUserId}-${receiver.role}`
    ],
    Admin: sender.messagingId,
    OtherUsers: [receiver.messagingId],
    JobId: job.job_id,
    CandidateId: job.candidate_id,
    Cadences: { jobseeker: 3, recruiter: 4 },
    EndConversationTimestamp: null,
    EndOrReenableActionDoer: null,
    ReEnableConversationTimestamp: null,
    DateApplied: job.date_applied,

    ...(channelMetadata && { channel: channelMetadata })
  };

  const params = {
    "messagingUserId": sender.messagingId,
    "channelName": channelName,
    "mode": "RESTRICTED",
    "privacy": "PUBLIC",
    "metadata": JSON.stringify(metadata)
  }

  return await axiosInstance.post(`/channel/create?unified=true`, JSON.stringify(params)).then((res)=> {
    let channelArn = res?.data?.ChannelArn ? res.data.ChannelArn : ""
    /* TJSKR-2393: open search integration */
    // openSearchChannelIndex(channelArn, sender?.messagingId, JSON.stringify(metadata), channelName )
    return { channelArn, metadata }
  }).catch(err => {
    throw err
  })
}

export const createUserArn = async (
 user: any
) => {
  const params = {
    "externalSystemUserId": user.externalUserId,
    "firstName": user.info.first_name,
    "lastName": user.info.last_name,
    "email": user.info.email,
    "mobilePhoneNumber": user.info.mobile,
    "role": user.role
  }
  return await axiosInstance.post(`/user/create`, JSON.stringify(params)).then((res)=> {
    let messagingUserId = res?.data?.MessagingUserId ?  res?.data?.MessagingUserId : null
    publishMessagingEvent("userCreated", messagingUserId, "", "", "", "", null, null)
    return messagingUserId
  }).catch(err => {
    throw err
  })
}

export const createChannelMembership = async (
  messagingUserId: string,
  channelArn: string,
) => {
  const params = {
    "messagingUserId": messagingUserId,
    "channelArn": channelArn
  }
  return await axiosInstance.post(`/channel/create-membership`, JSON.stringify(params)).then(()=> {
    publishMessagingEvent("memberAdded", messagingUserId, channelArn, "", "", "", null, null)
    return true
  }).catch(err => {
    throw err
  })
}

export const updateReadMarker = async (
  messagingUserId: string,
  channelArn: string,
  isSelf: boolean,
  receiver: any
) => {
  const params = {
    "messagingUserId": messagingUserId,
    "channelArn": channelArn
  }

  const receiverMessagingUserId = receiver?.messagingId ? receiver?.messagingId : (receiver?.userArn ? receiver?.userArn : receiver?.messaging_id)
   const metadata = {
    "OtherUsers": [`${receiverMessagingUserId}+${receiver?.role}`]
  }
  return await axiosInstance.post(`/channel/read-marker?unified=true`, JSON.stringify(params)).then(()=> {
    publishMessagingEvent("readMarkerSet", messagingUserId, channelArn, "", "", JSON.stringify(metadata), isSelf, null)
    /* TJSKR-2393: open search integration */
    // openSearchUpdateReadMarker(messagingUserId, channelArn)
    return true
  }).catch(err => {
    throw err
  })
}

export const decryptData = async (str: string) => {
  return Buffer.from(str, 'base64').toString('binary')
}

export const encryptData = async (str: string) => {
  return Buffer.from(str, 'binary').toString('base64')
}

export const publishMessagingEvent = async (
  eventName : string | null,
  messagingUserId : string | null,
  channelArn : string | null,
  messageId : string | null,
  applicantGuid : string | null,
  metadata : string | null,
  isSelf: boolean | null,
  messageContent: string | null
) => {
  const params = {
    "eventName" : eventName,
    "app" : isAndroid ? "android" : ( isIOS ? "iOS" : "Web" ),
    "eventDateTime" : new Date().toISOString(),
    "messagingUserId" : messagingUserId,
    "channelArn" : channelArn,
    "messageId" : messageId,
    "osVersion" : osVersion,
    "applicantGuid" : applicantGuid,
    "metadata" : metadata,
    "isSelf": isSelf,
    "content": messageContent
  }
  return await axiosInstance.post(`/publish/message/event`, JSON.stringify(params))
  .then(() => {
    return true
  }).catch(err => {
    return err
  })
}

export const getStoredMessagingAuth = () => {
  return {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem(`${process.env.REACT_APP_ENV}-messaging`)
  }
}

// Push Notification
export const sendPushNotification = async (
  messagingUserId: string | null,
  targetArn: string | null,
  gcm: string | null
) => {
  const params = {
    "messagingUserId": messagingUserId,
    "targetArn": targetArn,
    "message": {
      "default": "default",
      "GCM": gcm
    }
  }
   return await axiosInstance.post(`/push-notification/publish`, params).then(res => {
    if (res && res.data) {
      return res.data
    }
    return null
  }).catch( err => {
    return err
  })
}

export const checkIsLastMessageSender = (messageList:any, loggedInUserArn: string) => {
  if(messageList && messageList.length > 0) {
    const lastMessage = messageList[messageList.length - 1]
    if (lastMessage && lastMessage.Sender && splitUserArn(lastMessage.Sender.Arn) === loggedInUserArn) {
      return true
    } else {
      return false
    }
  }
  return false
}

export const updateUserTimezone = async (messagingUserId: string, timezone: string) => {
  const params = {
    messagingUserId,
    timezone
  }
  return await axiosInstance.post(`/user/update-timezone`, JSON.stringify(params)).then(res => {
  })
}

export const truncateText = (text: string, maxLen: number) => {
  return (text.length > maxLen) ? text.slice(0, maxLen) + '...' : text
}

export const validateQuickConnectToken = async (token: string) => {
  try {
    return await axiosInstance.get(`/quick-connect/validate/${token}`).then(res => {
      const status = res?.data?.status
      const message = res?.data?.message
      if(status == "failed") {
        if (message == "Access token has expired") {
          logInfo('quick_connect_expired_access', 'validateQuickConnectToken', 'Error validating quick connect token', undefined, { token, message})
          return "expired"
        } else {
          logInfo('quick_connect_invalid_token', 'validateQuickConnectToken', 'Error validating quick connect token', undefined, { token, message})
          return "invalid"
        }
      } else {
        setXApiKey(token)
        return res
      }
    })
  } catch (error) {
    logError(error as Error, 'validateQuickConnectToken', { message: 'Error on validating quick connect token'})
    return null
  }
}

export const requestNewQuickConnectAccess = async (token: string) => {
  try {
    return axiosInstance.get(`/quick-connect/renew/${token}`).then(res => {
        if(res?.status == 200 && res?.data?.status === 'success') {
          return true
        }
        return false
    }).catch(err => {
      logInfo('renew_quick_connect_token_error', 'requestNewQuickConnectAccess', 'Error renewing quick connect token', undefined, { error: err })
      return false
    })
  } catch (error) {
    logInfo('renew_quick_connect_token_error', 'requestNewQuickConnectAccess', 'Error renewing quick connect token', undefined, { error })
    return false
  }
}

export const getChannelDetails = async (
  channelArn: string,
  messagingUserId: string
) => {
  const params = {
    channelArn,
    messagingUserId
  }
   return await axiosInstance.post(`/channel/details`, JSON.stringify(params)).then(res => {
      if (res && res.data) {
        return res.data
      }
    return null
  }).catch( err => {
    return err
  })
}

export const getChannelMembershipDetails = async (
  channelArn: string | null,
  messagingUserId: string
  ) => {
  if(channelArn && messagingUserId) {
    const params = {
      channelArn,
      messagingUserId
    }
    return await axiosInstance.post(`/channel/membership-details`, JSON.stringify(params)).then(res => {
        if (res && res.data) {
          return res.data
        }
      return null
    }).catch( err => {
      return err
    })
  } else {
    return null
  }
}

export const getChannelMembers = async (
  channelId: string,
  messagingUserId: string,
  nextToken: string | null
) => {
  const channelArn = getChannelArn(channelId)
  if(channelArn && messagingUserId) {
    const params = {
      channelArn,
      messagingUserId,
      nextToken
    }
    return await axiosInstance.post(`/channel/list-members`, JSON.stringify(params)).then(res => {
        if (res && res.data) {
          return res.data
        }
      return null
    }).catch( err => {
      return err
    })
  } else {
    return null
  }
}


export const getJobDetails = async (jobId: string) => {
  try {
   requestConnectionHeader().then((res) =>{
   })
    const response = await jobseekerAxiosInstance.get(`/get/job/info?jobId=${jobId}`,
      { headers: {
        'Content-Type': 'application/json',
        'Authorization': await requestConnectionHeader(),
        'x-api-key': `${process.env.REACT_APP_CONNECTIONS_X_API_KEY}`
      }}
    )
    return response?.data?.data
  } catch (error) {
    logInfo('get_job_details_error', 'getJobDetails', 'Error getting job details', undefined, { jobId, error })
    return null
  }
}

// Format the location data into a string
const formatLocation = (loc: any) => {
  if (!loc) return '';
  if (Array.isArray(loc)) {
    return loc.map(location => {
      const parts = [location.city, location.region, location.country].filter(Boolean);
      return parts.join(', ');
    }).join(' | ');
  } else {
    const parts = [loc.city, loc.region, loc.country].filter(Boolean);
    return parts.join(', ');
  }
};

export const formQuickConnectChatData = async (quickConnectData: any) => {
  let chatData = {}
  if(quickConnectData) {
    const channelDetails = await getChannelDetails(quickConnectData.channel, quickConnectData.sender_id)
    const jobData = await getJobDetails(quickConnectData.job_id)
    if(!jobData || !channelDetails) return null
    const lookupUser = await getUserInstanceArnv2(null, null, quickConnectData.receiver_id)

    // Format the job data
    const job = {
      ...jobData,
      locations: formatLocation(jobData.locations)
    };

    chatData = {
      token: null,
      receiver: {
        external_user_id: null,
        first_name: quickConnectData.sender_fname,
        last_name: quickConnectData.sender_lname,
        messaging_id: quickConnectData.sender_id,
        role: "Recruiter",
        terms_agreed: true
      },
      sender: {
        external_user_id: null,
        first_name: "",
        last_name: "",
        messaging_id: quickConnectData.receiver_id,
        role: "Jobseeker",
        terms_agreed: lookupUser?.TermsOfServiceAccepted
      },
      channel: channelDetails?.Channel,
      connections: {
        isBlocked: false,
        isBlockedLink: false
      },
      job
    }
    return chatData
  } else {
    logInfo('invalid_quick_connect_token', 'formQuickConnectChatData', 'Error: Invalid quick connect token')
    return null
  }
}

export const setAwsSession = async (userArn: string) => {
  try {
    axiosInstance.get(`/cognito/get/token`).then(res => {
      if(res.status === 200) {
        const tempToken = res.data?.token
        decryptData(tempToken).then(async res => {
          const creds = JSON.parse(res)
          AWS.config.region = keys.AWS_REGION
          AWS.config.update({
            accessKeyId: creds?.code,
            secretAccessKey: creds.user,
            sessionToken: creds.token
          })
          messagingService.connect(userArn)
      })
      } else {
        logInfo('aws_session_retry', 'setAwsSession', 'AWS Error in aws keys: Retrying...', res.status)
        setTimeout(setAwsSession, 30 * 1000)
      }
    })
  } catch(error) {
    logError(error as Error, 'setAwsSession', { action: 'cognito_retry', message: 'Cognito error: Retrying...' })
    setTimeout(setAwsSession, 30 * 1000)
  }
}

const requestConnectionHeader = async () => {
  try {
    const connectionToken = await jobseekerAxiosInstance.get(`/get/conn/token`,
      { headers: {
        'Content-Type': 'application/json',
        'x-api-key': `${process.env.REACT_APP_CONNECTIONS_X_API_KEY}`
      }}
    )
    const decryptedToken = await decryptData(connectionToken?.data?.token)
    return decryptedToken
  } catch (error) {
    logInfo('connection_header_error', 'requestConnectionHeader', 'Error getting connections key', undefined, { error })
    return ''
  }
}

/* MSGT-4899: Sourcer channels are flagged in the channel metadata as channel.jtChannelType = 'SOURCER' */
export const isSourcerChannel = (metadata: string | null | undefined) => {
  if (!metadata) return false
  try {
    return JSON.parse(metadata)?.channel?.jtChannelType === 'SOURCER'
  } catch {
    return false
  }
}

export const formatDateTime = (isoString: string | number | Date) => {
  const date = new Date(isoString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  const formattedTime = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
  return `${formattedTime} - ${formattedDate}`;
}

export const formatDateTime2 = (isoString: string | number | Date) => {
  const date = new Date(isoString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  const formattedTime = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
  return `${formattedDate} ${formattedTime}`;
}

export const compareTimestamp = (lastMessageTimestamp: string, readMarkerTimestamp: string) => {
  const lastMessageDateTime = new Date(lastMessageTimestamp)
  const readMarkerDateTime = new Date(readMarkerTimestamp)
  if(!readMarkerDateTime) {
    return false
  } else if(lastMessageDateTime && lastMessageDateTime < readMarkerDateTime) {
    return true
  } else {
    return false
  }
}

/* TJSKR-2399: OPEN SEARCH INTEGRATION */
/* Function to index channel information */
export const openSearchChannelIndex = async (channelArn: string, messagingUserId: string, metaData: string, channelName: string) => {
  const params = { channelArn, messagingUserId, metaData, channelName }

  try {
    axiosInstance.post('/index/channel', JSON.stringify(params))
  } catch (error) {
    logInfo('opensearch_channel_index_error', 'openSearchChannelIndex', 'Error on indexing channel for open search', undefined, { channelArn, messagingUserId, error })
  }
}

/* Function to update read marker of indexed channel */
export const openSearchUpdateReadMarker = async (messagingUserId: string, channelArn: string) => {
  const params = { messagingUserId, channelArn }
  try {
    axiosInstance.post('/update/channel/read/marker', JSON.stringify(params))
  } catch (error) {
    logInfo('opensearch_read_marker_error', 'openSearchUpdateReadMarker', 'Error on updating read marker for open search', undefined, { messagingUserId, channelArn, error })
  }
}

/* Function to update channel marker of indexed channel*/
export const openSearchUpdateChannelMarker = async (messagingUserId: string,  channelArn: string, marker: string) => {
  const params = { messagingUserId, channelArn, marker}
  try {
    axiosInstance.post('/update/channel/marker', JSON.stringify(params))
  } catch (error) {
    logInfo('opensearch_channel_marker_error', 'openSearchUpdateChannelMarker', 'Error on updating marker in open search', undefined, { messagingUserId, channelArn, marker, error })
  }
}

export const fetchCompanyUsers = async (companyId: number) => {
  try {
    const response = await axiosInstance.get(`/company/${companyId}/users`)
    return response.data
  } catch (error) {
    logError(error as Error, 'fetchCompanyUsers', { companyId })
  }
}

/* TJSKR-2409 OPEN SEARCH IMPLEMENTATION */
export const fetchAllChannels = async ( channels: any[], messagingUserId: string, size: number, from: number, channelArn: string ): Promise<any[]> => {
  const params = { messagingUserId, size, from, channelArn }
  /* UPDATED: CHANGED TO GET OPEN SEARCH CHANNELS ENDPOINT */
  try {
    const response = await axiosInstance.get(`/search/channels`, { params })
    const { ChannelMemberships } = response?.data
    if (!ChannelMemberships) {
      return channels || []
    }
    const appendedChannels = channels ? [...channels, ...ChannelMemberships] : ChannelMemberships;
    if (ChannelMemberships.length >= from + size) {
      return await fetchAllChannels(appendedChannels, messagingUserId, size, from + size, "");
    }

    return appendedChannels
  } catch (error) {
    logError(error as Error, 'fetchAllChannels', { messagingUserId, size, from })
    return channels || []
  }
}

export const getJobseekerUnreadCount = async (jobseekerId: string, messagingUserId: string) => {
  const params = {
    jobseekerId,
    messagingUserId
  }
  return await axiosInstance.post(`/jobseeker/channel/list-membership`, JSON.stringify(params)).then(res => {
    return res?.data?.count_unread_messages || 0
  }).catch(err => {
    logError(err as Error, 'getJobseekerUnreadCount', { jobseekerId, messagingUserId })
    return 0
  })
}

/* TJSKR-3131 */
export const connectToMessagingWebsocket = (websocketConnection: any, onPresenceMessage?: (message: any) => void) => {
  const { connectToWebsocket, jtToken, messagingUserId } = websocketConnection
  if(connectToWebsocket) {
    const websocketUrl = jtToken ?
      new URL(`${process.env.REACT_APP_MESSAGING_WEBSOCKET!}?token=${jtToken}`) :
      new URL(`${process.env.REACT_APP_MESSAGING_WEBSOCKET!}?messaging_user_id=${messagingUserId}`)
      const socket = new WebSocket(websocketUrl)

      socket.onopen = () => {
        // logInfo('websocket_connected', 'connectToMessagingWebsocket', 'WebSocket connected')
      }

      socket.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data)
          if((message.type).toLowerCase() === WEBSOCKET_PRESENCE_MESSAGE || WEBSOCKET_CONNECTED_MESSAGE) {
            /* Handle online presence */
            if (onPresenceMessage) {
              onPresenceMessage(message);
            }
          }
        } catch (error) {
          logInfo('websocket_parse_error', 'connectToMessagingWebsocket', 'Failed to parse WebSocket message', undefined, { data: event.data, error })
        }
      }

      socket.onerror = (error) => {
        logInfo('websocket_error', 'connectToMessagingWebsocket', 'WebSocket error occurred', undefined, { error: error.type })
      }

      socket.onclose = () => {
        logInfo('websocket_disconnected', 'connectToMessagingWebsocket', 'WebSocket disconnected')
      }

      return socket
  }
}

export const formatReadTimestamp = (timestamp: string | number | Date, timezone: string | null) => {
  const now = new Date();
  const readDate = new Date(timestamp);
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    ...(timezone ? { timeZone: timezone } : {})
  };

  const isToday = now.toDateString() === readDate.toDateString();
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = yesterday.toDateString() === readDate.toDateString();

  if (isToday) {
    return `Read at ${readDate.toLocaleTimeString([], options)}`;
  } else if (isYesterday) {
    return `Read yesterday at ${readDate.toLocaleTimeString([], options)}`;
  } else if (now.getTime() - readDate.getTime() < 7 * 24 * 60 * 60 * 1000) {
    const day = readDate.toLocaleDateString(undefined, { weekday: 'long' });
    return `Read on ${day} at ${readDate.toLocaleTimeString([], options)}`;
  } else {
    return `Read on ${readDate.toLocaleDateString()} at ${readDate.toLocaleTimeString([], options)}`;
  }
}

export const fetchJobseekerNumbers = async (messagingUserId: string) => {
  try {
    const res = await axiosInstance.get(`/user/${messagingUserId}/phone`);

    const phoneNumbers = res?.data?.Data?.phoneNumbers || [];

    return phoneNumbers;
  } catch (err) {
    logError(err as Error, "fetchJobseekerNumbers", {messagingUserId: messagingUserId});
    return [];
  }
};

export const updateJobseekerNumber = async (phoneId: any, payload: any) => {
  try {
    const res = await axiosInstance.put(`/phone/${phoneId}`, payload);
    return res?.data || null;
  } catch (err) {
    logError(err as Error, "updateJobseekerNumber", {phoneId: phoneId, payload: payload});
    return null;
  }
};

export const addJobseekerNumber = async (messagingUserId: string, payload: any) => {
  try {
    const res = await axiosInstance.post(`/user/${messagingUserId}/phone`, payload);
    return res?.data;
  } catch (err) {
    logError(err as Error, "addJobseekerNumber", {messagingUserId: messagingUserId, payload: payload});
    return null;
  }
};

export const deleteJobseekerNumber = async (phoneId: any) => {
  try {
    const res = await axiosInstance.delete(`/phone/${phoneId}`);
    return res?.data || null;
  } catch (err) {
    logError(err as Error, "updateJobseekerNumber", {phoneId: phoneId});
    return null;
  }
};

export function hasSmsOptIn(
  phoneNumbers: { SmsOptIn: boolean }[]
): boolean {
  return phoneNumbers.some(entry => entry.SmsOptIn);
}